import axios, { AxiosPromise } from 'axios'

export interface ImpressaoAgendamentoInput {
  lotacaoId: ID
  date: Date
  isAgendaAd: Boolean
  nomeProfissional: string
}

export interface ImpressaoComprovanteAgendamentoInput {
  agendamentoId: ID
  nomeCidadao: string
}

export class ImpressaoAgendamento {
  gerarAgendamentos(input: ImpressaoAgendamentoInput): AxiosPromise<Blob> {
    return axios.post('/api/agendamento/gerarImpressao', input, { responseType: 'blob' })
  }
  gerarComprovanteAgendamento(input: ImpressaoComprovanteAgendamentoInput): AxiosPromise<Blob> {
    return axios.post('/api/agendamento/gerarImpressaoComprovanteAgendamento', input, { responseType: 'blob' })
  }
}
